export enum Modal {
  ConfirmCleanup = 'confirmCleanup',
  CreativeLibrary = 'creativeLibrary',
  DynamicContentBuilder = 'dynamicContentBuilder',
  Image = 'image',
  MovableInk = 'movableInk',
  SnippetSelector = 'snippetSelector',
  ViewChanges = 'viewChanges',
}
